import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import CustomerView from "../../CustomerCreation/CustomerView";
import SupplierView from "../SupplierCreation/SupplierView";

import { FaInfoCircle, FaMoneyCheckAlt, FaFileAlt } from "react-icons/fa";
import { useLocation } from "react-router-dom";
const CustomTab = ({ label, icon, ...props }) => (
  <Tab
    label={
      <span className="flex items-center space-x-2">
        <span className="text-lg transition-transform duration-200 group-hover:scale-110 group-[.Mui-selected]:scale-110 group-[.Mui-selected]:text-white">
          {icon}
        </span>
        <span className="font-semibold group-[.Mui-selected]:text-white">
          {label}
        </span>
      </span>
    }
    className=" group relative text-sm font-medium 
               transition-all duration-300 ease-in-out
               hover:text-blue-500 hover:bg-blue-100 hover:shadow-sm hover:scale-90 hover:rounded-md
               [&.Mui-selected]:text-white 
               [&.Mui-selected]:bg-blue-500
               [&.Mui-selected]:border-b-4 [&.Mui-selected]:border-blue-700
               [&.Mui-selected]:shadow-md
               [&.Mui-selected]:rounded-md
               focus:outline-none focus:ring-0 focus:ring-none focus:ring-opacity-0 text-white
               px-4 py-3 rounded-t-lg
               min-w-[120px] md:min-w-[150px]"
    sx={{
      "&:focus": {
        zIndex: 10, // Ensure focus state is visible above other tabs
      },
    }}
    aria-label={label}
    {...props}
  />
);

const BusinessPartnersDashboard = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const tabIndexFromChild = location.state?.tabIndex;

    if (typeof tabIndexFromChild === "number") {
      setTabIndex(tabIndexFromChild);
    } else {
      setTabIndex(0); // default when not from supplier creation
    }

    window.history.replaceState({}, document.title);
  }, [location.state]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  return (
    <div className="mx-4">
      <h2 className="text-xl text-gray-800 mb-4">Business Partners</h2>

      <div className=" border-b  p-2">
        <div className="rounded-md">
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            className=""
            TabIndicatorProps={{
              className: "hidden", // Hide default MUI indicator
            }}
          >
            <CustomTab label="Customers" icon={<FaInfoCircle className="" />} />
            <CustomTab label="Suppliers" icon={<FaFileAlt className="" />} />
          </Tabs>
        </div>
      </div>

      <div className="">
        {tabIndex === 0 && (
          <div className="space-y-6">
            <CustomerView />
          </div>
        )}
        {tabIndex === 1 && <div className="space-y-6">{<SupplierView />}</div>}
      </div>
    </div>
  );
};

export default BusinessPartnersDashboard;
